export default __webpack_public_path__ + "static/media/student_three.df65657a.png";